export type Theme = {
  colors: {
    primary: string;
    secondary: string;
    accent: string;
    success: string;
    danger: string;
    warning: string;
    info: string;
    bg: string;
    bgAlt: string;
    card: string;
    text: string;
    muted: string;
    border: string;
    link: string;
    subtle: string;
    overlay: string;
    gradients: {
      primary: string; // CSS gradient string
    };
  };
};

export const theme: Theme = {
  colors: {
    // Brand (elegant, slightly muted)
    primary: '#5563de',
    secondary: '#7a5ccf',
    accent: '#2ea3f2',

    // Semantic (softened)
    success: '#2fbf71',
    danger: '#e25555',
    warning: '#f2b34c',
    info: '#5aa3ff',

    // Surfaces
    bg: '#f7f8fc',
    bgAlt: '#eef1f6',
    card: '#ffffff',

    // Typography
    text: '#111827',
    muted: '#64748b',

    // Lines
    border: '#e6e8ee',

    // Links
    link: '#4f67ff',

    // Subtle surfaces / overlays
    subtle: '#f3f6fb',
    overlay: 'rgba(0,0,0,0.5)',

    // Gradients (brand)
    gradients: {
      primary: 'linear-gradient(135deg, #5563de 0%, #7a5ccf 100%)'
    }
  }
};

export default theme;


